/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 酸素投与手段
 */
export type VitalO2MeanEnum =
  (typeof VitalO2MeanEnum)[keyof typeof VitalO2MeanEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VitalO2MeanEnum = {
  NASAL_CANNULA: 'NASAL_CANNULA',
  FACE_MASK: 'FACE_MASK',
  VENTURI: 'VENTURI',
  RESERVOIR_MASK: 'RESERVOIR_MASK',
  BVM: 'BVM',
  VENTILATOR: 'VENTILATOR',
  OTHER: 'OTHER',
  NONE: 'NONE',
} as const;
